import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import FormModalContainer from '../../../../components/Modals/FormModalContainer'
import OfoqThemeBtn from '../../../../components/Buttons/OfoqThemeBtn'
import StepOne from './StepOne'
import StepThree from './StepThree'
import { isNotEmpty } from '../../../../utils/helpers'
import { customerAdminSelectUsers } from '../../../../redux/features/users/customerAdmin/customerAdminSlice'
import { getCountForAllNonRegisterUsers, postBulkCreateForAllUsers } from '../../../../redux/features/users/customerAdmin/customerAdminThunk'
import UseTranslation from '../../../../hooks/UseTranslation'
import StepTwo from './StepTwo'
import FinishModalContainerV2 from '../../../../components/Modals/FinishModalContainerV2'
import { creationUsersBatchFinish } from '../../../../utils/finishDataContiner'

function CreationUsersBatchModal({ modalState, setModalState }) {
  const users = useSelector(customerAdminSelectUsers)
  const dispatch = useDispatch()
  const { t } = UseTranslation()
  const [finishModalState, setFinishModalState] = useState(false)
  const [currentStep, setCurrentStep] = useState(1)
  const [language, setLanguage] = useState()
  const history = useHistory()

  useEffect(() => {
    dispatch(getCountForAllNonRegisterUsers())
  }, [])

  const handleClose = (showFinishModal = false) => {
    setModalState(false)
    setCurrentStep(1)
    setLanguage(null)
    if (showFinishModal === true) {
      setFinishModalState(true)
    }
  }

  const getStepTitle = () => {
    switch (currentStep) {
      case 1: return `${t?.next}`
      case 2: return `${t?.['Create Users']}`
      case 3: return `${t?.['Yes, Create']}`
      default: return `${t?.next}`
    }
  }

  const actionTitle = getStepTitle()

  const handelBackOrCancel = () => {
    if (currentStep === 3) {
      setCurrentStep((prev) => prev - 1)
    } else {
      handleClose()
    }
  }

  const handelNextOrSave = () => {
    if (currentStep === 2 && isNotEmpty(language)) {
      setCurrentStep((prev) => prev + 1)
    } else if (currentStep === 1) {
      setCurrentStep((prev) => prev + 1)
    } else if (currentStep === 3) {
      dispatch(postBulkCreateForAllUsers({
        queries: { language: language?.name?.toUpperCase() },
      })).then((res) => {
        if (res?.meta?.requestStatus === 'fulfilled') {
          handleClose(true)
        }
      })
    }
  }

  return (
    <Box>
      <FormModalContainer
        modalState={modalState}
        handleClose={handleClose}
        modalTitle={t?.['Users Batch Creation']}
        mediumSize
        customStyle={{ p: '20px' }}
      >
        {currentStep === 1 && <StepOne count={users.allNonRegisterUsersCount} />}
        {currentStep === 2 && <StepTwo
          language={language}
          setLanguage={setLanguage}
          count={users.allNonRegisterUsersCount}
        />
        }
        {currentStep === 3 && <StepThree
          language={language}
          count={users.allNonRegisterUsersCount}
        />}

        <Box sx={styles.buttonsContainer}>
          <OfoqThemeBtn name={currentStep === 3 ? `${t?.back}` : `${t?.cancel}`} cancelStyle onClick={handelBackOrCancel}
          customStyle={styles.cancelBtn}
          />
          <OfoqThemeBtn name={actionTitle} onClick={handelNextOrSave}
          customStyle={styles.saveBtn}

          />
        </Box>

      </FormModalContainer>

      <FinishModalContainerV2
        modalState={finishModalState}
        actionAfterSuccess={() => setFinishModalState(false)}
        finishHandler={'FinishHandler'}
        modalData={creationUsersBatchFinish}
      >
        <Typography sx={styles.finishMsg}>
       {`${t?.['You can monitor the Processing Status from']} `}
        <Typography component={'span'} sx={styles.finishMsgSpan}
        onClick={() => history.push('users/batch-actions-status')}
        >
         {`${t?.['Batch Action Status Screen']}`}
          </Typography>
        </Typography>

      </FinishModalContainerV2>
    </Box>
  )
}

const styles = {
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: 'solid 1px #e3e4ed',
    marginTop: { xs: '10px', sm: '40px' },
    padding: '20px 10px 10px 10px',
  },
  cancelBtn: { display: { xs: 'none', sm: 'initial' } },
  saveBtn: {
    minWidth: { xs: '100%', sm: 'initial' },
    minHeight: '40px',
    fontSize: '14px',
  },
  finishMsg: { color: '#92929D', textAlign: 'center', mt: '16px' },
  finishMsgSpan: { color: '#29CC8B', textDecoration: 'underline', cursor: 'pointer' },
  finishModel: {
    height: { xs: 'fit-content', sm: 'auto' },
    transform: { xs: 'translate(-50%, 6%)', sm: 'translate(-50%, -50%)' },
    ' & button': {
      width: { xs: '100%', sm: 'auto' },
    },
  },
}

export default CreationUsersBatchModal
